import { _x } from '@wordpress/i18n'
import classNames from 'classnames'
import { useCallback, useEffect, useRef } from 'react'
import { useMenu } from 'react-instantsearch'
import type { SwiperContainer } from 'swiper/element/bundle'
import { WP_LOCALE } from '../../../../assets/utils/algolia/algoliaLocalization'

function ServiceFilters() {
  const { items: languageMenuItems, refine: refineLanguage } = useMenu({
    attribute: `languages.fullName.${WP_LOCALE}`,
    sortBy: ['count:desc', 'name:asc']
  })

  const { items: tagsMenuItems, refine: refineTags } = useMenu({
    attribute: `tags.title.${WP_LOCALE}`,
    sortBy: ['count:desc', 'name:asc']
  })

  const { value: languageValue } = languageMenuItems.find(
    (item) => item.isRefined
  ) || {
    value: ''
  }

  const { value: tagValue } = tagsMenuItems.find((item) => item.isRefined) || {
    value: ''
  }

  const onLanguageChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value
      refineLanguage(value === languageValue ? '' : value)
    },
    [languageValue, refineLanguage]
  )

  const onTagChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value
      refineTags(value === tagValue ? '' : value)
    },
    [tagValue, refineTags]
  )

  const swiperRef = useRef<SwiperContainer>(null)

  useEffect(() => {
    const swiper = swiperRef.current
    if (swiper) {
      Object.assign(swiper, {
        navigation: false,
        slidesPerView: 'auto',
        spaceBetween: 8,
        freeMode: true
      })
      swiper.initialize()
    }

    return () => {
      if (swiper) {
        swiper.disconnectedCallback()
      }
    }
  }, [])

  const isEmpty = languageMenuItems.length <= 1 && tagsMenuItems.length === 0

  return (
    <div
      className={classNames('services-filters', {
        'mb-4': !isEmpty
      })}
    >
      <fieldset className="m-0">
        <legend className="visually-hidden">
          {_x('Filter by language', 'Services Filter Language', 'icf')}
        </legend>
        <swiper-container
          ref={swiperRef}
          init="false"
          /* @ts-ignore */
          class="services-filter-slider"
        >
          {languageMenuItems.length > 1
            ? languageMenuItems.map((item) => (
                <swiper-slide key={item.value} style={{ width: 'auto' }}>
                  <input
                    id={`services-filter-language-${item.label}`}
                    type="checkbox"
                    className="btn-check"
                    name="language"
                    value={item.value}
                    checked={item.isRefined}
                    onChange={onLanguageChange}
                    autoComplete="off"
                  />
                  <label
                    className="btn filter-tag-button is-purple"
                    htmlFor={`services-filter-language-${item.label}`}
                  >
                    {item.label}
                  </label>
                </swiper-slide>
              ))
            : null}
          {tagsMenuItems.map((item) => (
            <swiper-slide key={item.value} style={{ width: 'auto' }}>
              <input
                id={`services-filter-tag-${item.label}`}
                type="checkbox"
                className="btn-check"
                name="language"
                value={item.value}
                checked={item.isRefined}
                onChange={onTagChange}
                autoComplete="off"
              />
              <label
                className="btn filter-tag-button is-purple"
                htmlFor={`services-filter-tag-${item.label}`}
              >
                {item.label}
              </label>
            </swiper-slide>
          ))}
        </swiper-container>
      </fieldset>
    </div>
  )
}

export default ServiceFilters
